import { memo } from 'react';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  order: string[];
  red: string[];
  green: string[];
  blue: string[];
}

const CaseWidgetTimeline = ({ order, red, green, blue }: Props) => {
  const classes = useStyles();

  return (
    <ul className={classes.list}>
      {order.map((item, idx) => {
        return (
          <li className={classes.item}>
            <div className={classes.separatorRoot}>
              <span
                className={clsx(classes.border, classes.borderLeft, {
                  [classes.hidden]: idx === 0,
                })}
              ></span>
              <span
                className={clsx(classes.dot, {
                  [classes.blue]: blue.includes(item),
                  [classes.green]: green.includes(item),
                  [classes.red]: red.includes(item),
                })}
              ></span>
              <span
                className={clsx(classes.border, classes.borderRight, {
                  [classes.hidden]: idx === order.length - 1,
                })}
              ></span>
            </div>
            <div className={classes.content}>
              <span
                className={clsx(classes.text, {
                  [classes.highlitedText]: !blue.includes(item),
                })}
              >
                {item}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default memo(CaseWidgetTimeline);
